import React, { FC, ReactNode, useEffect } from 'react';
import styles from './assets/seance-list-screen.module.scss';
import classNames from 'classnames';
import SeancesGrid from './components/SeancesGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import AdminLayout from 'src/components/layout/RoleLayout';
import { ISeance } from 'src/types/seance';
import Loader from '../../../../../../components/Loader';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';
import { IProvider } from '../../../../../../types/provider';
import { RouteComponentProps } from 'react-router';
import { useCookies } from 'react-cookie';
import moment from 'moment';

export interface StateProps {
    provider: IProvider | null;
    data: Paginated<ISeance>;
    inProgressCSV: boolean;
    inProgress: boolean;
    providers: SelectObject[];
    districts: SelectObject[];
    vendors: SelectObject[];
    students: SelectObject[];
}

export interface DispatchProps {
    getProviderData: (id: string | number) => void;
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
}
interface RouteParams {
    id: string;
}
export interface OwnProps extends RouteComponentProps<RouteParams> {}
export interface StateParams {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ProviderAnalyticsEditScreen: FC<Props> = (props: Props) => {
    //class ProviderAnalyticsEditScreen extends React.Component<Props, StateParams> {

    const {
        match: {
            params: { id },
        },
        providers,
        provider,
        districts,
        vendors,
        students,
        data,
        getData,
        getProviderData,
        getProviders,
        getStudents,
        getDistricts,
        getVendors,
        getDataCsv,
        inProgressCSV,
        inProgress,
    } = props;

    useEffect(() => {
        getProviderData(id);
        if (!providers.length) {
            getProviders({
                page: 1,
                itemsPerPage: 800,
            });
        }
        if (!students.length) {
            getStudents({
                page: 1,
                itemsPerPage: 800,
            });
        }
        if (!vendors.length) {
            getVendors({
                page: 1,
                itemsPerPage: 800,
            });
        }
        if (!districts.length) {
            getDistricts({
                page: 1,
                itemsPerPage: 800,
            });
        }

        if (!data) {
            getData({
                page: 1,
                //itemsPerPage: pageSize,
                filters: { 'provider.id': id },
                //sorting: getPreparedSorting(),
            });
        }

        // eslint-disable-next-line
    }, []);

    const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
    const isSupervisor = user.getSupervisor();

    const [cookiesDateFrom, setCookieDateFrom] = useCookies(['fromDate']);
    const [cookiesDateTo, setCookieDateTo] = useCookies(['toDate']);

    let dateLabel = '';

    if (cookiesDateFrom.fromDate !== 'undefined' && cookiesDateTo.toDate !== 'undefined') {
        dateLabel =
            'for (' +
            (cookiesDateFrom.fromDate ? moment(cookiesDateFrom.fromDate).format('MMM D, YYYY') : '') +
            ' - ' +
            (cookiesDateTo.toDate ? moment(cookiesDateTo.toDate).format('MMM D, YYYY') : '') +
            ')';
    }

    return (
        <AdminLayout>
            {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
            <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                    {provider?.fullName + "'s"} metrics {dateLabel}
                    <span>{data.totalCount ? '(' + data.totalCount + ')' : ''}</span>
                </h2>
            </div>
            {inProgress ? <Loader /> : null}
            <div className={classNames(styles.list)}>
                <SeancesGrid
                    vendors={vendors}
                    districts={districts}
                    students={students}
                    providers={providers}
                    provider={id}
                    data={data}
                    getData={getData}
                    getDataCsv={getDataCsv}
                    inProgressCSV={inProgressCSV}
                />
            </div>
        </AdminLayout>
    );
};

export default ProviderAnalyticsEditScreen;
